import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { printLabelFromUrl } from '../utils/printLabel';
import { printViaPrintAgent } from '../utils/printAgent';

interface ReprintLabelButtonProps {
  labelUrl: string;
  className?: string;
  style?: React.CSSProperties;
}

const ReprintLabelButton: FC<ReprintLabelButtonProps> = ({
  labelUrl,
  className = 'btn btn-info',
  style,
}) => {
  const [reprinting, setReprinting] = useState(false);
  const intl = useIntl();

  const handleReprint = async () => {
    setReprinting(true);
    try {
      const printed = await printViaPrintAgent(labelUrl);
      if (!printed) {
        await printLabelFromUrl(labelUrl);
      }
      toast.success(intl.formatMessage({ id: 'picking.printSuccess' }));
    } catch {
      toast.error(intl.formatMessage({ id: 'picking.printError' }));
    } finally {
      setReprinting(false);
    }
  };

  return (
    <button
      className={className}
      style={style}
      onClick={handleReprint}
      disabled={reprinting}
    >
      {reprinting ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" />
          {intl.formatMessage({ id: 'picking.reprinting' })}
        </>
      ) : (
        intl.formatMessage({ id: 'picking.reprintLastLabel' })
      )}
    </button>
  );
};

export { ReprintLabelButton };
